import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef, DynamicDialogConfig } from "primeng/dynamicdialog";
import { UserService } from "../../../../shared";
import { SchoolService } from "../../../../shared/services/school.service";
import { SchoolSettingsService } from "../../services/adminsettings.service";
import { SUPrefSelectRequest } from "../../services/SUPrefSelectRequest";
import { SUPrefUpdateRequest } from "../../services/SUPrefUpdateRequest";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";

@Component({
	selector: "app-supreference-settings",
	templateUrl: "./supreference-settings.component.html",
	styleUrls: ["./supreference-settings.component.css"],
})
export class SUPreferenceSettingsComponent implements OnInit {
	constructor(
		private selectService: SchoolselectorService,
		public ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private schoolService: SchoolService,
		private schoolSettingsService: SchoolSettingsService,
		private userService: UserService,
		private confirmationService: ConfirmationService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		this.subscription = this.selectService.onSchoolChanged().subscribe((school) => {
			// this.SchoolID = school.SchoolID;
			this.onSchoolChange(school);
		});

		this.loadCategories();
	}

	ngOnDestroy() {
		this.subscription.unsubscribe();
	}

	////////////////////////////////////////////////////////////////////
	// Data
	////////////////////////////////////////////////////////////////////
	SchoolID: any;

	Processing: any = false;

	SchoolLoading: any = false;
	lstSchool: any = [];
	School: any;

	CategoryLoading: any = false;
	lstCategory: any = [];
	Category: any;

	Filter: any = "";

	lastSearch: any = {
		SchoolID: -9999999,
		Category: "-9999999",
		Filter: "",
	};

	NewValue: any = "";

	subscription: any;
	SchoolSelectShowAll: any = false;

	lstExtraOptions: any = [
		{
			SchoolID: -1,
			SchoolNumber: "-1",
			SchoolName: "Any School",
			SchoolFullName: "Any School",
		},
		{
			SchoolID: 0,
			SchoolNumber: "0",
			SchoolName: "District Level Only",
			SchoolFullName: "District Level Only",
		},
	];

	///////////////
	// Built-In
	///////////////

	user: any;
	pagerows: any = 10;
	pagefirst: any = 0;
	loading: any = false;
	errorMessage: any = "";

	///////////////

	///////////////
	// Custom
	///////////////

	//Main
	SelectedPreference: any;
	lstPreference: any = [];

	//Filter lists
	lstScopeDesc: any = [];
	// lstFilterCategory: any = [];
	lstHasNotesDesc: any = [];

	//Cols
	cols: any = [
		//INSERT CUSTOM COLUMNS HERE
		{ field: "Category", header: "Category" },
		{ field: "KeyName", header: "Key Name" },
		{ field: "KeyValue", header: "Key Value" },
		{ field: "ScopeDesc", header: "Scope" },
		// { field: 'Notes', header: 'Notes'}
	];

	///////////////

	////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////
	// Load Data
	////////////////////////////////////////////////////////////////////

	loadSchools() {
		this.SchoolLoading = true;

		var result = this.schoolService.loadSchoolList("");
		result.subscribe(
			(response) => {
				this.lstSchool = response;

				this.lstSchool.unshift({
					SchoolID: 0,
					SchoolNumber: "",
					SchoolName: "District",
					SchoolFullName: "District",
				});

				this.lstSchool.unshift({
					SchoolID: -1,
					SchoolNumber: "",
					SchoolName: "Any",
					SchoolFullName: "Any",
				});

				this.School = this.lstSchool[0];

				this.SchoolLoading = false;

				this.loadCategories();
			},
			(error) => {
				this.SchoolLoading = false;
			}
		);
	}

	loadCategories() {
		this.CategoryLoading = true;

		var result = this.schoolSettingsService.CategorySelectAll();
		result.subscribe(
			(response) => {
				this.lstCategory = response;

				this.lstCategory.unshift({
					Category: "Any",
				});

				this.Category = this.lstCategory[0];

				this.CategoryLoading = false;
				// this.loadPreferences();
			},
			(error) => {
				this.CategoryLoading = false;
			}
		);
	}

	loadPreferences() {
		this.loading = true;

		this.errorMessage = "";
		this.SelectedPreference = null;

		let parms: SUPrefSelectRequest = {
			SchoolID: this.School.SchoolID,
			UserID: this.user.userID,
			Category: this.Category.Category,
			Filter: this.Filter,
		};

		this.lastSearch.SchoolID = this.School.SchoolID;
		this.lastSearch.Category = this.Category.Category;
		this.lastSearch.Filter = this.Filter;

		var result = this.schoolSettingsService.SUPreferenceSelectList(parms);
		result.subscribe(
			(response) => {
				this.lstPreference = response;

				this.lstScopeDesc = Array.from(new Set(this.lstPreference.map((item: any) => item.ScopeDesc))).sort();
				// this.lstFilterCategory = Array.from(new Set(this.lstPreference.map((item: any) => item.Category))).sort();
				this.lstHasNotesDesc = Array.from(new Set(this.lstPreference.map((item: any) => item.HasNotesDesc))).sort();

				this.loading = false;
			},
			(error) => {
				this.loading = false;
			}
		);
	}

	////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////
	// Buttons
	////////////////////////////////////////////////////////////////////
	onSearch() {
		this.loadPreferences();
	}

	onUpdate() {
		this.errorMessage = "";

		if (this.SelectedPreference == undefined) {
			this.errorMessage = "Select a Preference to Update";
			return;
		}

		if (String(this.SelectedPreference.KeyValue) == String(this.NewValue)) {
			this.errorMessage = "New Value = Old Value";
			return;
		}

		if (this.TrimSpaces(this.NewValue) == "") {
			this.ConfirmUpdateBlank();
		} else {
			this.ConfirmUpdate();
		}
	}

	ConfirmUpdateBlank() {
		this.confirmationService.confirm({
			key: "ConfirmSU",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: 'Warning: You are about to update the value "' + this.SelectedPreference.KeyValue + '" to a blank value. Do you want to proceed?',
			header: "WARNING",
			icon: "fa",
			accept: () => {
				this.FinishUpdate();
			},
			reject: () => {
				return;
			},
		});
	}

	ConfirmUpdate() {
		this.confirmationService.confirm({
			key: "ConfirmSU",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message:
				'Warning: You are about to update the value "' + this.SelectedPreference.KeyValue + '" to "' + this.NewValue + '". Do you want to proceed?',
			header: "WARNING",
			icon: "fa",
			accept: () => {
				this.FinishUpdate();
			},
			reject: () => {
				return;
			},
		});
	}

	FinishUpdate() {
		this.Processing = true;

		let parms: SUPrefUpdateRequest = {
			PreferenceID: this.SelectedPreference.PreferenceID,
			KeyVal: this.NewValue,
		};

		var result = this.schoolSettingsService.SUPrefUpdate(parms);
		result.subscribe(
			(response) => {
				this.Processing = false;

				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "SUPref",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Preference was updated successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadPreferences();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "SUPref",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not update the preference",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////
	// Events
	////////////////////////////////////////////////////////////////////

	onSchoolChange(val) {
		this.School = val;
	}

	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {
		this.errorMessage = "";
		this.SelectedPreference = val.data;

		this.NewValue = this.SelectedPreference.KeyValue;
	}
	onRowUnselect(val) {
		this.errorMessage = "";
		this.SelectedPreference = null;

		this.NewValue = "";
	}
	onRowDblClick(Preference) {
		this.SelectedPreference = Preference;
	}
	////////////////////////////////////////////////////////////////////

	////////////////////////////////////////////////////////////////////
	// Helpers
	////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.SchoolLoading == true || this.CategoryLoading == true || this.loading == true || this.Processing == true;
	}

	// SearchChanged(){
	//   return (
	//     this.lastSearch.SchoolID != this.School.SchoolID ||
	//     this.lastSearch.Category != this.Category.Category ||
	//     this.lastSearch.Filter != this.Filter
	//   )
	// }

	TrimSpaces(val: string) {
		while (val.indexOf(" ") != -1) {
			val = val.replace(" ", "");
		}

		return val;
	}

	////////////////////////////////////////////////////////////////////
}
